module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.10095/images/glasses-colourful-scarf/glasses-colourful-scarf@2x.png"